import classNames from 'classnames';
import { useTranslation } from 'next-i18next';
import React, { useEffect, useState } from 'react';

import { InputField } from '@/shared/components/atoms';
import useDebounce from '@/shared/hooks/useDebounce';

import Clear from '~/images/shared/CloseWithoutBG.svg';
import SearchIcon from '~/images/shared/search.svg';

const Search: React.FC<ISearchProps> = ({
  resetDeps = [],
  onSearch,
  onClick,
  resetFn,
  className,
  px,
  py,
  width,
  placeholder,
  searchKeyword,
}) => {
  const { t, i18n } = useTranslation('common');

  const [keyword, setKeyword] = useState('');

  const debouncedSearch = useDebounce(keyword, 500);
  const handleReset = () => {
    setKeyword('');
    if (resetFn) resetFn();
  };
  useEffect(() => {
    if (onSearch)
      onSearch(debouncedSearch === '' ? undefined : debouncedSearch);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [debouncedSearch]);

  //  INFO: clear keyword with tab change
  useEffect(() => {
    setKeyword('');
    //  TODO: fix clear delay
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, resetDeps);

  useEffect(() => {
    if (searchKeyword !== undefined) setKeyword(searchKeyword);
  }, [searchKeyword]);

  return (
    <div
      onClick={onClick}
      className={classNames('flex cursor-text', width ?? 'basis-388')}
    >
      <InputField
        onChange={(e) => {
          setKeyword(e.target.value);
        }}
        value={keyword}
        prefix={<SearchIcon width='22' height='22' />}
        suffix={
          <span onClick={handleReset} className='cursor-pointer'>
            <Clear />
          </span>
        }
        placeholder={placeholder ?? t('search')}
        className={classNames(
          i18n.dir() === 'ltr' ? '!pl-56' : '!pr-56',
          'rounded-xl bg-background-300',
          className
        )}
        width='w-full'
        placeholderColor='placeholder:text-text-600'
        borderColor='border-outline-variant'
        fontSize='text-base'
        textColor='text-primary-default'
        py={py ?? '!py-16'}
        px={px ?? 'px-16'}
        iconColor='text-text-600'
        iconSize='xs'
      />
    </div>
  );
};

export default Search;
